import SurveyDetail from './surveyDetails.container';
export default SurveyDetail;